import { render, staticRenderFns } from "./forgotphonepassword.vue?vue&type=template&id=05cf162c"
import script from "./forgotphonepassword.vue?vue&type=script&lang=js"
export * from "./forgotphonepassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports